// extracted by mini-css-extract-plugin
export default {"logo_wrap":"logo_logo_wrap__GNQqZ","titletext":"logo_titletext__qewFa","bootontext":"logo_bootontext__oTf05","logoA":"logo_logoA__aseMo"};